"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4299],{

/***/ 4299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_SliderContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/uikit/Buttons/InvertedLink.tsx
var InvertedLink = __webpack_require__(80764);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Slider/index.tsx






const SliderBox = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(5365)]).then(__webpack_require__.bind(__webpack_require__, 65365)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(65365)]
  }
});

const Slider = _ref => {
  let {
    title,
    subtitle,
    image,
    boxes,
    contactAction,
    contactHref
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
    w: "full",
    h: {
      base: '29.375rem',
      md: '34.938rem'
    },
    pb: "9",
    background: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.1)), url(${image})`,
    backgroundColor: "white",
    backgroundSize: "cover",
    backgroundPosition: "center top no-repeat",
    marginBottom: "2rem !important",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
      mx: "auto",
      marginTop: {
        md: '12.5rem',
        sm: '2.5rem'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        as: "h1",
        color: "baseWhite",
        fontFamily: "Montserrat-SemiBold",
        fontSize: {
          base: '1.5rem',
          md: '2.25rem'
        },
        lineHeight: {
          base: '1.938rem',
          md: '2.925rem'
        },
        letterSpacing: ".67px",
        whiteSpace: "pre-wrap",
        my: {
          base: 'xxl',
          md: '0'
        },
        mx: {
          base: 'safeAreaMobile',
          md: '0'
        },
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        display: {
          base: 'none',
          md: 'block'
        },
        as: "h2",
        color: "baseWhite",
        fontFamily: "Montserrat-Regular",
        fontSize: "1.375rem",
        fontWeight: "normal",
        lineHeight: "1.75rem",
        letterSpacing: ".6px",
        whiteSpace: "pre-wrap",
        marginTop: ".7rem !important",
        marginBottom: "2rem !important",
        children: subtitle
      }), contactAction && contactHref && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        justify: "center",
        mb: "3rem !important",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(InvertedLink/* default */.Z, {
          href: contactHref,
          action: contactAction,
          title: contactAction
        })
      }), boxes && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
        columns: {
          base: 1,
          sm: 2,
          md: 2
        },
        spacing: {
          base: '2.875rem',
          md: 120
        },
        position: "relative",
        children: boxes.map(box => /*#__PURE__*/(0,jsx_runtime.jsx)(SliderBox, {
          image: box.image,
          title: box.title,
          description: box.description,
          action: box.action,
          actionMobile: box.actionMobile || null,
          href: box.href,
          alt: box.alt,
          target: box.target
        }, box.title))
      })]
    })
  });
};

/* harmony default export */ var components_Slider = (Slider);
// EXTERNAL MODULE: ./src/containers/data/slider.json
var slider = __webpack_require__(34755);
;// CONCATENATED MODULE: ./src/containers/SliderContainer.tsx




const contactHref = '/contatti?utm_source_button=carplanner-slider';

const SliderContainer = () => /*#__PURE__*/(0,jsx_runtime.jsx)(components_Slider, {
  title: slider/* title */.TN,
  image: slider/* image */.BH,
  subtitle: slider/* subtitle */.Oc,
  boxes: slider/* boxes */.qk,
  contactAction: slider/* contact.action */.PX.a,
  contactHref: contactHref
});

/* harmony default export */ var containers_SliderContainer = (SliderContainer);

/***/ }),

/***/ 80764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53918);
/* harmony import */ var src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2732);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




const StyledLink = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].a.withConfig({
  componentId: "sc-6umwyd-0"
})(["background-color:", ";color:", ";border-radius:4px;border:1px solid rgb(46,197,141);text-transform:uppercase;", ";padding:0.94rem ", " 0.88rem ", ";&:hover{background-color:", ";border-color:", ";", ";}&:active{background-color:", ";border-color:", ";", ";}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.baseWhite;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.palette.primaryGreen900;
}, src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__/* .TextStyles.interactiveButtonsSG900SemiboldC */ .k.interactiveButtonsSG900SemiboldC, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spaces.spacing_xl;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spaces.spacing_xl;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.palette.primaryGreen900;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.palette.primaryGreen900;
}, src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__/* .TextStyles.interactiveButtonsSWhiteSemiboldC */ .k.interactiveButtonsSWhiteSemiboldC, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.palette.primaryGreen800;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.palette.primaryGreen800;
}, src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_3__/* .TextStyles.interactiveButtonsSWhiteSemiboldC */ .k.interactiveButtonsSWhiteSemiboldC);

const InvertedButtonLink = _ref9 => {
  let {
    action,
    href,
    title,
    target
  } = _ref9;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, {
    target: target || '_self',
    href: href,
    title: title || action,
    children: action
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (InvertedButtonLink);

/***/ })

}]);